import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { CodeListItemDescriptor } from './model/codelist.item';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';

@Injectable()
export class CodeListItemService extends RESTServiceBase {

  constructor(
    authService: AuthService,
    config: AppConfig
  ) {
    super(
      'v1',
      'CodeListItemManagement',
      authService,
      config.CLMSConfig
    );
  }

  public create(CodeListItem: CodeListItemDescriptor): Promise<CodeListItemDescriptor> {
    return super.post<CodeListItemDescriptor>(
      new CodeListItemDescriptor({
        id: undefined,
        href: undefined,
        codeListId: CodeListItem.codeListId,
        name: CodeListItem.name,
        description: CodeListItem.description,
        sortOrder: CodeListItem.sortOrder,
        organizationId: CodeListItem.organizationId,
        validFrom: CodeListItem.validFrom,
        validUntil: CodeListItem.validUntil,
        modified: CodeListItem.modified,
        deleted: CodeListItem.deleted
      }));
  }

  async GetList(v: View): Promise<List<CodeListItemDescriptor>> {
    return await this.getCodeListItems(v);
  }
  async GetById(id: string): Promise<CodeListItemDescriptor> {
    return await this.getById(id);
  }

  public getCodeListItems(view?: View): Promise<List<CodeListItemDescriptor>> {
    return super.get<List<CodeListItemDescriptor>>(undefined, view);
  }

  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  public update(id: string, CodeListItem: CodeListItemDescriptor): Promise<CodeListItemDescriptor> {
    return super.put<CodeListItemDescriptor>(id, CodeListItem);
  }

  public getById(id: string): Promise<CodeListItemDescriptor> {
    return super.get<CodeListItemDescriptor>(id);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/codelist.item/codelist.item.service.ts